import { cx } from 'class-variance-authority';
const root = cx([
    'w-color-picker h-color-picker rounded-color-picker',
    'transition-all duration-150 ease-in-out',
    'ring-offset-[0px]',
    'hover:ring-offset-[3px] active:ring-offset-[3px] focus-visible:ring-offset-[3px]',
    'ring-transparent ring-color-picker ring-offset-[var(--color-bg)]',
    'hover:ring-color-picker-hover',
    'active:ring-color-picker-press ',
    'data-[state=on]:ring-offset-[3px] data-[state=on]:ring-color-picker-selected',
    'focus-visible:ring-color-picker-focus',
    'outline-none',
    'disabled:cursor-not-allowed disabled:ring-0 disabled:grayscale',
]);
export const styles = {
    root,
};
